import { useEffect, useState } from "react";

const navItems = [
  { id: "hot", label: "热榜速览", icon: "ri-fire-line" },
  { id: "lexicon", label: "名词速览", icon: "ri-book-2-line" },
  { id: "reads", label: "深读文章", icon: "ri-article-line" },
  { id: "facts", label: "冷知识", icon: "ri-lightbulb-line" },
  { id: "faq", label: "常见问题", icon: "ri-question-line" },
  { id: "about", label: "关于我们", icon: "ri-group-line" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jump = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 border-b border-background-200/80 backdrop-blur-md"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        {/* 品牌 */}
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
            setOpen(false);
          }}
          className="flex items-center gap-2.5 cursor-pointer"
        >
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-primary-600 text-background-50">
            <span className="absolute inset-1 rounded-full bg-accent-500/30"></span>
            <i className="ri-quill-pen-fill text-base leading-none relative"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              吃瓜百科
            </span>
            <span className="mt-1 text-[10px] tracking-[0.25em] text-foreground-500">
              看热闹 · 也看门道
            </span>
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                jump(item.id);
              }}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100/70 hover:text-primary-800 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={() => jump("lexicon")}
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 sm:inline-flex cursor-pointer"
          >
            <i className="ri-search-line text-sm leading-none"></i>
            开始查词
          </button>

          {/* 汉堡 */}
          <button
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 md:hidden cursor-pointer"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl leading-none`}></i>
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden"
          aria-label="移动端导航"
        >
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    jump(item.id);
                  }}
                  className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100/70 cursor-pointer"
                >
                  <i className={`${item.icon} text-base leading-none text-primary-600`}></i>
                  {item.label}
                </a>
              </li>
            ))}
            <li className="mt-2">
              <button
                onClick={() => jump("lexicon")}
                className="w-full whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-700 cursor-pointer"
              >
                开始查词
              </button>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}